import { render } from "./enroll.vue?vue&type=template&id=55bed440&scoped=true"
import script from "./enroll.vue?vue&type=script&lang=js"
export * from "./enroll.vue?vue&type=script&lang=js"

import "./enroll.vue?vue&type=style&index=0&id=55bed440&lang=less&scoped=true"
import "./enroll.vue?vue&type=style&index=1&id=55bed440&lang=css"

import exportComponent from "/Users/aiden/Desktop/hujian/hongyu/edu-web-mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55bed440"]])

export default __exports__